import React, { useEffect } from 'react'
import CanvasComponent from './Canvas'
import Cookies from "universal-cookie";
import { Toaster } from 'react-hot-toast';
import { fetchWrapper } from './app/RomeDataManager';
import { setUserRole } from './Actions/ApplicationStateAction';
import { useDispatch } from 'react-redux';

export const cookies = new Cookies();
const App = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    const response = fetchWrapper.get(
      `/floorplans/is_floorplan_draw_user`,
    );
    response.then(
      (data) => {
        if(data.data.floorplan_draw_user) {
          dispatch(setUserRole("verifier"))
        }
      }
    )
  }, []);

  return (
    <div>
      <Toaster position="top-center" reverseOrder={false} />
      <CanvasComponent/>
    </div>
  )
}

export default App
